<script setup lang="ts">
import type { ConsultantKpiPeriod } from "@asap/shared/schemas/team-member-data";
import { AwButton } from "@asap/design";

const period = defineModel<ConsultantKpiPeriod>({ required: true });

withDefaults(defineProps<{ disabled?: boolean }>(), { disabled: false });

const periodOptions: { value: ConsultantKpiPeriod; label: string }[] = [
  { value: "month", label: "Mois" },
  { value: "week", label: "Semaine" },
];

const selectPeriod = (value: ConsultantKpiPeriod) => {
  period.value = value;
};

const ui = {
  group: "inline-flex h-[34px] shrink-0 items-center rounded-md bg-secondary-100 p-0.5",
  button: "!h-[30px] !py-0",
};
</script>

<template>
  <div :class="ui.group" role="radiogroup" aria-label="Période">
    <AwButton
      v-for="option in periodOptions"
      :key="option.value"
      type="button"
      size="sm"
      color="secondary"
      :class="ui.button"
      :variant="period === option.value ? 'solid' : 'ghost'"
      :disabled="disabled"
      role="radio"
      :aria-checked="period === option.value"
      @click="selectPeriod(option.value)"
    >
      {{ option.label }}
    </AwButton>
  </div>
</template>
